import { ICON__eye_slash_solid, ICON__eye_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { use_slice_user } from '@/hooks/store/use_slices';
import { FN_USER_SETTINGS__update } from '@/utils/utils_client';

interface PROPS {}

export function G_HEADER__generations_history_button_show_hidden_generations({}: PROPS) {
  /*
   * STORE
   */

  const { user_settings } = use_slice_user(['user_settings']);

  /*
   * STATE
   */

  /*
   * EFFECTS
   */

  /*
   * EVENTS
   */

  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let user_settings_new = user_settings.clone();
    user_settings_new.generation_show_hidden_generations = !user_settings_new.generation_show_hidden_generations;

    await FN_USER_SETTINGS__update(user_settings_new);
  }
  /*
   * METHODS
   */

  /*
   * METHODS
   */

  /*
   * RENDERS
   */

  /*
   * HTML
   */

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      variant="no-border-on-component"
      size="full-6"
      {...{ onClick }}
      className=""
      iconClassNameBase="size-3 text-component-item-foreground"
      iconClassNameHovered=""
      Icon={user_settings.generation_show_hidden_generations ? ICON__eye_slash_solid : ICON__eye_solid}
    />
  );
}
